import Model from './Model'

export default class Manufacturer extends Model {

    schema() {
        return {
            id: null,
            shop_id: null,
            name: null,
            connector_name: null,
            cron_stock_enabled: null,
            pim_use_ref: null,
            created_at: null,
            updated_at: null,
            synchro_file_list: null,
            files: [],
            connector: {},
        }
    }

}
